
import styled from 'styled-components'

export const TitleSection = styled.h2`
    font-size: calc(2.5em + 1.7vw);
    @media screen and (max-width: 768px){
        text-align: center;
        width: initial !important;
    }
`

